var buildPromotionBanner = function buildPromotionBanner(eventType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isVideo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    content_type: isVideo ? 'video' : data == null ? void 0 : data.contentType,
    creative_name: "".concat(data == null ? void 0 : data.page, ":magalu:").concat(isVideo ? 'video' : data == null ? void 0 : data.contentType),
    creative_slot: "".concat(data == null ? void 0 : data.position, ":").concat(data == null ? void 0 : data.slot),
    dimension4: data == null ? void 0 : data.campaignId,
    event: eventType,
    location_id: "".concat(data == null ? void 0 : data.size, ":").concat(data == null ? void 0 : data.page, ":banner").concat((data == null ? void 0 : data.contentType) === 'banner_list' ? ":".concat((data == null ? void 0 : data.index) + 1) : ''),
    motorBanner: 'topsort',
    screenName: data == null ? void 0 : data.screenName
  };
};
var buildPromotionBrandBanner = function buildPromotionBrandBanner(eventType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    ad_type: 'sponsored_brands',
    content_type: 'sponsored_brands',
    creative_name: "".concat(data == null ? void 0 : data.page, ":magalu:sponsored_brands"),
    creative_slot: "".concat(data == null ? void 0 : data.position, ":").concat(data == null ? void 0 : data.slot),
    dimension4: data == null ? void 0 : data.campaignId,
    event: eventType,
    location_id: "".concat(data == null ? void 0 : data.page, ":magalu:").concat(data == null ? void 0 : data.vendorId),
    motorBanner: 'topsort',
    screenName: data == null ? void 0 : data.screenName
  };
};
var buildPromotionVideo = function buildPromotionVideo() {
  var _data$ad_type;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    ad_type: (_data$ad_type = data == null ? void 0 : data.ad_type) !== null && _data$ad_type !== void 0 ? _data$ad_type : null,
    content_type: 'video',
    creative_slot: data == null ? void 0 : data.creative_slot,
    event: eventType,
    video_current_time: data == null ? void 0 : data.video_current_time,
    video_duration: data == null ? void 0 : data.video_duration,
    video_percent: data == null ? void 0 : data.video_percent,
    video_provider: 'interno',
    video_url: data == null ? void 0 : data.video_url,
    visible: 'true'
  };
};
export var selectPromotionBanner = function selectPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('select_promotion', data);
};
export var selectPromotionBannerVideo = function selectPromotionBannerVideo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('select_promotion', data, true);
};
export var selectPromotionBrandBanner = function selectPromotionBrandBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBrandBanner('select_promotion', data);
};
export var videoCompletePromotionBanner = function videoCompletePromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_complete');
};
export var videoProgressPromotionBanner = function videoProgressPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_progress');
};
export var videoStartPromotionBanner = function videoStartPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_start');
};
export var viewPromotionBanner = function viewPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('view_promotion', data);
};
export var viewPromotionBannerVideo = function viewPromotionBannerVideo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('view_promotion', data, true);
};
export var viewPromotionBrandBanner = function viewPromotionBrandBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBrandBanner('view_promotion', data);
};